import { generateList } from "@kidslivesafe/sc-foundation";
import {
  Button,
  Chit,
  Container,
  GoogleStreetViewStatic,
  Layout,
  Padding,
  Text,
} from "@kidslivesafe/sc-react";
import React from "react";

import "./pre-foreclosure-popUp.css";
import { preForeclosureData } from "../../../features/reports/reportTypes";
import { formatNumberCommas, fullCapsText } from "../../../utils";
import { MemberEvent } from "../../../features/admin/adminTypes";

interface PreForeclosurePopUpProps {
  preForeclosureItem: preForeclosureData;
  brandInfoMarkerColor: string;
  pullPropertyReport: (report: any) => void;
  memberEventMarketSearch: (event: MemberEvent) => void;
}

const PreForeclosurePopUp: React.FC<PreForeclosurePopUpProps> = ({
  preForeclosureItem,
  brandInfoMarkerColor,
  pullPropertyReport,
  memberEventMarketSearch,
}) => {
  const renderChit = ({ text }: { text: string }) => {
    switch (text) {
      case "Pre-foreclosure":
        return (
          <Chit size="xxs" unresponsive chitText={text} dotColor="green" />
        );
      case "Auction Scheduled":
        return (
          <Chit size="xxs" unresponsive chitText={text} dotColor="yellow" />
        );
      case "Auction Complete":
        return (
          <Chit size="xxs" unresponsive chitText={text + "d"} dotColor="red" />
        ); // BE reasons
    }
  };

  const pullPreForclosurePropertyReport = (address: preForeclosureData) => {
    memberEventMarketSearch({
      EventCategory: "View Foreclosure",
      EventAction: "Button Click",
      MetaData: JSON.stringify({
        source: "map",
      }),
    });
    pullPropertyReport(address);
  };

  return (
    <Container customClassName="pre-foreclosure-popUp" bodyBorderRadius>
      <GoogleStreetViewStatic
        lat={preForeclosureItem.latitude}
        long={preForeclosureItem.longitude}
        size={{ height: 189, width: 400 }}
        staticMapFlag
        staticMapProperties={{
          markerColor: brandInfoMarkerColor,
          markerSize: "mid",
          zoom: 19,
        }}
      />
      <Container customClassName="pre-foreclosure-popUp__body">
        <div className="pre-foreclosure-popUp__body__chit-container">
          {renderChit({
            text: preForeclosureItem.propertyPfcType,
          })}
        </div>
        <Padding space="xxs" top="lg">
          <Layout type="flex" flexProps={{ direction: "column", gap: "xs" }}>
            <Layout type="flex" flexProps={{ direction: "column", gap: "xxs" }}>
              <Text unresponsive size="xxs" fontWeight="bold">
                {preForeclosureItem.landUseDescription
                  ? fullCapsText(preForeclosureItem.landUseDescription)
                  : "N/A"}
              </Text>
              <Layout
                type="flex"
                flexProps={{
                  direction: "row",
                  gap: "xs",
                }}
                breakpointStyles={{
                  desktop: {
                    type: "flex",
                    flexProps: {
                      direction: "row",
                      gap: "xs",
                      justifyContent: "space-between",
                    },
                  },
                }}
              >
                <Text unresponsive size="xxs">
                  {generateList(
                    [
                      {
                        value: " bds",
                        label: preForeclosureItem.bedrooms,
                      },
                      {
                        value: " ba ",
                        label: preForeclosureItem.totalBaths
                          ? preForeclosureItem.totalBaths
                          : "--",
                      },
                      {
                        value: " sqft ",
                        label:
                          preForeclosureItem.sumBuildingSqFt &&
                          formatNumberCommas(
                            preForeclosureItem.sumBuildingSqFt,
                          ),
                      },
                    ],
                    " | ",
                  )}
                </Text>
              </Layout>

              <Text
                size="xxs"
                passThroughClassess="pre-foreclosure-popUp__body__address"
                unresponsive
              >
                {preForeclosureItem.fullAddress}
              </Text>
            </Layout>
            <Button
              buttonText={
                <Text size="sm" unresponsive>
                  View Details
                </Text>
              }
              handleClick={() => {
                pullPreForclosurePropertyReport(preForeclosureItem);
              }}
              color="secondary"
            />
          </Layout>
        </Padding>
      </Container>
    </Container>
  );
};

export default PreForeclosurePopUp;
